import { usePriceLookup as useSharedPriceLookup } from '@/hooks/use-price-lookup';
import { DetailRow } from '../components/form-dialog/hooks/useDetailRows';
import { useHoaDonBanHangSearchContext } from '../context/index';

interface PriceLookupResponse {
  gia_nt2?: number;
  [key: string]: BanHangValue;
}

export function usePriceLookup() {
  const { ngayCt, customerGroupUuid } = useHoaDonBanHangSearchContext();

  return useSharedPriceLookup<DetailRow, PriceLookupResponse>({
    endpoint: '/erp/purchase-prices/price-lookup/',
    effectiveDate: ngayCt,
    extraKey: customerGroupUuid,
    triggerFields: ['ma_vt_data', 'dvt'],
    debounceFields: [],
    manualPriceFields: ['gia_nt2'],
    buildRequest: ({ itemUuid, unit, effectiveDate }) => ({
      ma_vt: itemUuid,
      dvt: unit,
      customer_group_uuid: customerGroupUuid || null,
      ...(effectiveDate ? { ngay_hl: effectiveDate.split('T')[0] } : {})
    }),
    buildUpdates: ({ response, quantity }) => {
      const gia_nt2 = Number(response.gia_nt2) || 0;
      const tien_nt2 = (Number(quantity) || 0) * gia_nt2;

      return { gia_nt2, tien_nt2 };
    }
  });
}
